import React from 'react'
import '../assets/css/header.css';
import '../assets/js/header.js';

function HomeHeader() {
  return (
    <>
      <header id="header" className="header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <a href="/" className="header__logo">
                <img className="header__logo__light" src="../assets/images/logo1.png" alt="Xipetech" />
              </a>
            </div>
          </div>
        </div>
      </header>
      <button className="menu__toggle" id="menu__toggle">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className="header__menu">
        <div className="menu__left">
          <div className="menu__container">
            <ul className="menu__list">
              <li>
                <a href="/" className="header__menu__link" id="home">
                  Home
                </a>
              </li>
              <li>
                <a href="/" className="header__menu__link" id="about">
                  About Us
                </a>
              </li>
              <li>
                <a href="/" className="header__menu__link" id="services">
                  Services
                </a>
              </li>
              <li>
                <a href="/" className="header__menu__link" id="projects">
                  Our Projects
                </a>
              </li>
              <li>
                <a href="/" className="header__menu__link" id="careers">
                  Careers
                </a>
              </li>
              <li>
                <a href="/" className="header__menu__link" id="contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="menu__right relative">
          <div className="menu__container position-relative">
            <div className="menu__scrollar">
              <div className="menu__box showDrop" data-id="home">
                <div className="menu__lg__menu">
                  <div className="home__menu__box">
                    <div className="home__menu__box__left">
                      <img className="rounded" src="../assets/images/service/seo.jpg" alt="" />
                    </div>
                    <div className="home__menu__box__right">
                      <div className="heading mb-3">
                        <h6>
                          <span>Home</span>
                        </h6>
                        <h4>
                          Xipe Tech is a Technological solutions company
                          providing the best kind of IT services for your
                          business with utmost professionalism.
                        </h4>
                      </div>
                      <a href="contact" className="menu__lg__link">
                        Connect with us
                        <img src="../assets/images/arrow-right2.svg" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="menu__box" data-id="about">
                <div className="home__menu__box">
                  <div className="home__menu__box__left">
                    <img className="rounded" src="../assets/images/about/why.png" alt="" />
                  </div>
                  <div className="home__menu__box__right">
                    <div className="heading mb-3">
                      <h6>
                        <span>About</span>
                      </h6>
                      <h4>
                        Testing Services, Custom application development, IT
                        consulting services and our best services like Software
                        Development, Web Design, Apps Development Services.
                      </h4>
                    </div>
                    <a href="contact" className="menu__lg__link">
                      Find Out More
                      <img src="../assets/images/arrow-right2.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu__box" data-id="services">
                <div className="service__lg__menu">
                  <ul className="service__list d-grid flex-wrap">
                    <li className="service__item">
                      <a href="/service-detail/web-development" className="service__box">
                        <div className="service__icon">
                          <img src="../assets/images/service/web-color-icon.svg" alt="" />
                        </div>
                        <h4>Web Development</h4>
                        <span className="service__cta">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </a>
                    </li>
                    <li className="service__item">
                      <a href="/service-detail/wordpress-development" className="service__box">
                        <div className="service__icon">
                          <img src="../assets/images/service/mobile-color-icon.svg" alt="" />
                        </div>
                        <h4>Wordpress Development</h4>
                        <span className="service__cta">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </a>
                    </li>
                    <li className="service__item">
                      <a href="/service-detail/android-development" className="service__box">
                        <div className="service__icon">
                          <img src="../assets/images/service/android-color-icon.svg" alt="" />
                        </div>
                        <h4>Android Development</h4>
                        <span className="service__cta">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </a>
                    </li>
                  </ul>
                  <div className="text-end mt-4">
                    <a href="contact" className="menu__lg__link">
                      Find Out More
                      <img src="../assets/images/arrow-right2.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu__box" data-id="projects">
                <div className="home__menu__box">
                  <div className="home__menu__box__left">
                    <img className="rounded" src="../assets/images/projects/projects.jpg" alt="" />
                  </div>
                  <div className="home__menu__box__right">
                    <div className="heading mb-3">
                      <h6>
                        <span>Our Projects</span>
                      </h6>
                      <h4>
                        Testing Services, Custom application development, IT
                        consulting services and our best services like Software
                        Development, Web Design, Apps Development Services.
                      </h4>
                    </div>
                    <a href="contact" className="menu__lg__link">
                      Find Out More
                      <img src="../assets/images/arrow-right2.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu__box" data-id="careers">
                <div className="home__menu__box">
                  <div className="home__menu__box__left">
                    <img className="rounded" src="../assets/images/career/career-menu.png" alt="" />
                  </div>
                  <div className="home__menu__box__right">
                    <div className="heading mb-3">
                      <h6>
                        <span>Career</span>
                      </h6>
                      <h4>We Help To Get The Best Job And Find A Talent</h4>
                      <p>
                        At Xipe Tech, we believe in fostering a dynamic and
                        inclusive work environment where talent thrives and
                        innovation flourishes. Join us on our journey to be a
                        leading provider of innovative IT solutions that
                        transform businesses and shape the future of technology
                      </p>
                    </div>
                    <a href="contact" className="menu__lg__link">
                      Apply Now
                      <img src="../assets/images/arrow-right2.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu__box" data-id="contact">
                <div className="menu__contact__box">
                  <div className="menu__contact__left">
                    <div className="menu__contact__items">
                      <div className="menu__contact__item">
                        <div className="menu__contact__icon">
                          <img src="../assets/images/email.png" alt="" />
                        </div>
                        <div>
                          <h6>Mail Address</h6>
                          <p>
                            <a href="mailto:hiring@xipetech.com" target="_blank">
                              hiring@xipetech.com
                            </a>
                          </p>
                        </div>
                      </div>
                      <div className="menu__contact__item">
                        <div className="menu__contact__icon">
                          <img src="../assets/images/location.png" alt="" />
                        </div>
                        <div>
                          <h6>Office Address</h6>
                          <p>
                            1st Floor, 529C/486, Kamla Nehru Nagar,
                            Jageshwarpuri, Shankar Purva-Ⅲ, Zone 7, Lucknow -
                            226022 Uttar Pradesh, India Landmark: Wedding Inn
                            Star Hotel
                          </p>
                        </div>
                      </div>
                      <div className="menu__contact__item">
                        <div className="menu__contact__icon">
                          <img src="../assets/images/call.png" alt="" />
                        </div>
                        <div>
                          <h6>Phone Number</h6>
                          <p>
                            <a href="tel:918090920216" target="_blank">
                              +91-8090-920216
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="menu__social__links">
          <a href="https://www.facebook.com/xipetech/" className="menu__social__link">
            <img src="../assets/images/social-icons/facebook.svg" alt="" />
          </a>
          <a href="https://twitter.com/xipetech/" className="menu__social__link">
            <img src="../assets/images/social-icons/twitter.svg" alt="" />
          </a>
          <a href="https://www.instagram.com/xipe.tech/" className="menu__social__link">
            <img src="../assets/images/social-icons/instagram.svg" alt="" />
          </a>
          <a href="https://www.linkedin.com/company/xipe-tech/" className="menu__social__link">
            <img src="../assets/images/social-icons/linkedin.svg" alt="" />
          </a>
          <a href="https://www.youtube.com/@XipeTechLucknow" className="menu__social__link">
            <img src="../assets/images/social-icons/youtube.svg" alt="" />
          </a>
        </div>
      </div>
    </>
  )
}

export default HomeHeader